// Module
var code = "<div class=\"alert {{notification.CssClass}}\" *ngIf=\"notification.Show\"> <span>{{notification.Message}}</span> <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"notification.Show = false;\"> <span aria-hidden=\"true\">&times;</span> </button> </div> ";
// Exports
export default code;